export default "__VITE_ASSET__CFdil866__"